import { UserGuideScope } from '../../../../../shared/types';
import { sortArray } from '../../../../../utils/sorting.utils';
import { GroupedUserGuideScopeRow } from '../types';

const getScopeWeight = (weight?: number): number =>
    typeof weight === 'number' && Number.isInteger(weight)
        ? weight
        : Number.MAX_SAFE_INTEGER;

export const groupUserGuideScopesByName = (
    items: UserGuideScope[]
): GroupedUserGuideScopeRow[] => {
    const groupedByName = new Map<string, GroupedUserGuideScopeRow>();

    items.forEach((item) => {
        const existing = groupedByName.get(item.name);

        if (!existing) {
            groupedByName.set(item.name, {
                ...item,
                scope: item.scope,
                scopes: [item.scope],
                weight: getScopeWeight(item.weight),
            });
            return;
        }

        existing.scopes.push(item.scope);
        existing.scope = existing.scopes.join(', ');
        existing.weight = Math.min(
            existing.weight,
            getScopeWeight(item.weight)
        );
    });

    return Array.from(groupedByName.values())
        .map((item) => {
            const orderedScopes = sortArray(item.scopes);
            return {
                ...item,
                scopes: orderedScopes,
                scope: orderedScopes.join(', '),
            };
        })
        .sort((first, second) => {
            if (first.weight !== second.weight) {
                return first.weight - second.weight;
            }

            return first.name.localeCompare(second.name);
        });
};
